import { anyOf, arrayOf, is, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

import { isConversationalInboundMessageTriggersSubscriptionGroup } from "../conversationalInboundMessageTriggers/validators";

const isConversationalReplyRoutingWorkflow = anyOf(
  objectOf({ id: string, name: string, audience_targeted: boolean, restricted: is(false) }),
  objectOf({ id: is(null), name: is(null), audience_targeted: boolean, restricted: is(true) })
);

export const isConversationalReplyRoutingResult = objectOf({
  workflows: arrayOf(isConversationalReplyRoutingWorkflow),
  keyword_categories: arrayOf(objectOf({ name: string, keywords: arrayOf(string) })),
  inbound_message_triggers: anyOf(isConversationalInboundMessageTriggersSubscriptionGroup, nullOrUndefined),
  limit: number,
});
